import { SgdfParticipantPicker } from './ParticipantPicker.js';
window.customElements.define('sgdf-participant-picker', SgdfParticipantPicker);
//# sourceMappingURL=sgdf-participant-picker.js.map